import React, { Component } from 'react';
import { Card } from "antd-mobile";
import {Button, Toast} from 'antd-mobile-v5';
import moment from "moment";
import {getDeliveryFiles} from "apis/material";
import { calculationDist, addSeparator } from 'common/util';
import './index.less';

export default class MaterialInfoCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            latitude: null,
            longitude: null,
            result: null,
            delivery: null
        }
    }

    componentDidUpdate(preProps, preState) {
        if (preProps.data !== this.props.data) {
            let { data } = this.props;
            let vbilltypecode = data?.vbilltypecode;
            let materialData = data?.deliveryBodys;
            let allData = [];
            let result = this.processData(materialData, vbilltypecode, allData);
            this.setState({
                result
            })
        }
    }

    processData = (materialData, type, allData) => { // 处理数据
        if (type && type === "4EAB") { // 表示此时为提货的数据 （装:卸 = 1:n）
            let repeatUnloadData = [],// 用来存放所有为 卸 且重复的数据（未处理的数据）
                sameAddress = [];
            materialData?.forEach(item => {
                repeatUnloadData.push({
                    type: 'unload',
                    code: item.receiveUnit?.code,
                    unit: item.receiveUnit?.name,
                    flag: item.receiveUnit?.code
                })
            });
            materialData?.forEach(item => {
                // sunb
                if (item.castunitid) {
                    item.material = Object.assign(item.material, { nnum: item.nnum }, { realnum: item.realnum }, { nastnum: item.nastnum }, { castunitidname: item.castunitid.name });
                } else {
                    item.material = Object.assign(item.material, { nnum: item.nnum }, { realnum: item.realnum });
                }
                // item.material = Object.assign(item.material, { nnum: item.nnum }, { realnum: item.realnum });
                sameAddress.push({
                    address: item.vreceiveaddress?.vaddress,
                    nlatitude: item.vreceiveaddress?.nlatitude,
                    nlongitude: item.vreceiveaddress?.nlongitude,
                    nradius: item.vreceiveaddress?.nradius,
                    vcode: item.vreceiveaddress?.vcode,
                    flag: item.receiveUnit?.code,
                    material: item.material,
                })
            })

            let unloadData = [];// 用来存放所有为 卸 且不重复的数据
            let unitCode = repeatUnloadData.map(item => {
                return item.code;
            })
            unitCode = [...new Set(unitCode)]; // 用来包裹的所有 卸 且是不重复的code的值

            let addressCode = sameAddress.map(item => {
                return item.vcode;
            })
            addressCode = [...new Set(addressCode)];

            unitCode.forEach(item => {
                let datas = [];
                let entity = {};
                repeatUnloadData.forEach(newItem => {
                    if (item === newItem.code) {
                        entity = newItem;
                    }
                })
                sameAddress.forEach(sameItem => {
                    if (item === sameItem.flag) {
                        datas.push(sameItem);
                    }
                })
                let contents = [...datas];
                unloadData.push({ contents, ...entity });
            })
            unloadData.forEach(item => {
                let newContent = [];
                let entity = {};
                for (let i = 0; i < item.contents.length; i++) {
                    let total = item.contents[i];
                    let materialData = item.contents[i].material;
                    if (!entity[total.vcode]) {
                        newContent.push({
                            materials: [materialData],
                            ...total
                        })
                        entity[total.vcode] = total;
                    } else {
                        for (let j = 0; j < newContent.length; j++) {
                            let repeatData = newContent[j];
                            if (repeatData.vcode === total.vcode) {
                                repeatData.materials.push(materialData);
                                break;
                            }
                        }
                    }
                }
                item.contents = newContent;
            })
            // console.log(unloadData);

            allData.push({
                type: 'load',
                unit: materialData[0]?.sendUnit?.name,
                contents: [{
                    address: materialData[0]?.vsendaddress?.vaddress,
                    nlatitude: materialData[0]?.vsendaddress?.nlatitude,
                    nlongitude: materialData[0]?.vsendaddress?.nlongitude,
                    nradius: materialData[0]?.vsendaddress?.nradius,
                }]
            })
            return allData = allData.concat(unloadData);
        } else if (type && type === "4EAC") { // 表示此时为送货的数据 （装:卸 = n:1）
            let repeatLoadData = [], // 用来存放所有为 装 且重复的数据（未处理的数据）
                sameAddress = [];
            materialData?.forEach(item => {
                repeatLoadData.push({
                    type: 'load',
                    code: item.sendUnit?.code,
                    unit: item.sendUnit?.name,
                    flag: item.sendUnit?.code
                })
            });
            materialData?.forEach(item => {
                item.material = Object.assign(item.material, { nnum: item.nnum }, { realnum: item.realnum });
                sameAddress.push({
                    address: item.vsendaddress?.vaddress,
                    nlatitude: item.vsendaddress?.nlatitude,
                    nlongitude: item.vsendaddress?.nlongitude,
                    nradius: item.vsendaddress?.nradius,
                    vcode: item.vsendaddress?.code,
                    flag: item.sendUnit?.code,
                    material: item.material,
                })
            })

            let loadData = []; // 用来存放所有为 装 且不重复的数据
            let unitCode = repeatLoadData.map(item => {
                return item.code
            })
            unitCode = [...new Set(unitCode)];

            let addressCode = sameAddress.map(item => {
                return item.vcode;
            })
            addressCode = [...new Set(addressCode)];

            unitCode.forEach(item => {
                let datas = [];
                let entity = {};
                repeatLoadData.forEach(newItem => {
                    if (item === newItem.code) {
                        entity = newItem;
                    }
                })
                sameAddress.forEach(sameItem => {
                    if (item === sameItem.flag) {
                        datas.push(sameItem);
                    }
                })
                let contents = [...datas];
                loadData.push({ contents, ...entity });
            })
            loadData.forEach(item => {
                let newContent = [];
                let entity = {};
                for (let i = 0; i < item.contents.length; i++) {
                    let total = item.contents[i];
                    let materialData = item.contents[i].material;
                    if (!entity[total.vcode]) {
                        newContent.push({
                            materials: [materialData],
                            ...total
                        })
                        entity[total.vcode] = total;
                    } else {
                        for (let j = 0; j < newContent.length; j++) {
                            let repeatData = newContent[j];
                            if (repeatData.vcode === total.vcode) {
                                repeatData.materials.push(materialData);
                                break;
                            }
                        }
                    }
                }
                item.contents = newContent;
            })
            allData.push({
                type: 'unload',
                unit: materialData[0]?.receiveUnit?.name,
                contents: [{
                    address: materialData[0]?.vreceiveaddress?.vaddress,
                    nlatitude: materialData[0]?.vreceiveaddress?.nlatitude,
                    nlongitude: materialData[0]?.vreceiveaddress?.nlongitude,
                    nradius: materialData[0]?.vreceiveaddress?.nradius,
                }]
            })
            return allData = loadData.concat(allData);
        }
    }

    switchStatus = () => {
        this.setState({
            show: !this.state.show
        })
    }

    getDeliveryFilesServlet = () => {
        const { data } = this.props;
        console.log('----------------------------getFile')
        console.log(data, '----------------------data');
        let param = {
            billid: data.pk_delivery,
            system: "app",
            pk_org: data.stockorg.pk_org,
            code: data.stockorg.code
        }
        let result =  getDeliveryFiles(param);

        result.then(res => {
            if (res) {
                let delivery = JSON.parse(res.data)
                if (delivery?.isbg === "N") {
                    Toast.show(`暂未上传报关单，请联系工厂`)
                } else if (delivery?.isbg === "Y") {
                    if (delivery?.filestr && delivery?.filetype) {
                        this.setState({
                            delivery: delivery
                        })
                    } else {
                        if (data?.stockorg?.pk_org === "0001A1100000000030MV") {
                            Toast.show(`已报关，可进入保税区`);
                        }
                    }
                }
            }
        }).catch(err => {
            console.error('获取报关单文件失败:', err)
        })
    }

    render() {
        const { data, latitude, longitude } = this.props;
        const { show, result, delivery } = this.state;
        let deliverySrc = (delivery?.filestr && delivery?.filetype) ? `data:${delivery.filetype};base64,${delivery.filestr}` : '';
        let vbilltypecode = data?.vbilltypecode;
        let vcardid = data?.vcardid ? data?.vcardid : "";
        let date = moment(new Date(data?.dbilldate?.replace(/\-/g, '/'))).format("YYYY-MM-DD");

        let iconStyle = show ? "header-icon-particulars" : "header-icon-simplification";
        let text = show ? "详情" : "精简"
        let showView = show ? "none" : "block"

        let list = result?.map((item, index) => {
            let showDate;
            if (vbilltypecode && vbilltypecode === "4EAB") {
                showDate = item.type === "load" ? "block" : "none"
            } else if (vbilltypecode && vbilltypecode === "4EAC") {
                showDate = item.type === "unload" ? "block" : "none"
            }

            let addressList = item.contents.map((aItem, index) => {
                let calculation = calculationDist(aItem.nlongitude, aItem.nlatitude, longitude, latitude); // 获取当前位置到目标位置的距离
                let dist; // 页面上显示距离工厂的距离
                if (calculation) {
                    if (calculation >= 1000) {
                        dist = (calculation / 1000).toFixed(1) + "km";
                    } else {
                        dist = calculation.toFixed(0) + "m";
                    }
                } else {
                    dist = "--m"
                }
                let materilaList = aItem.materials?.map((mItem, index) => {
                    let assignWeight = mItem.nnum;
                    assignWeight = assignWeight ? addSeparator(assignWeight) : '';
                    let realWeight = mItem.realnum?.toFixed(mItem.bitnumber);
                    realWeight = realWeight ? addSeparator(realWeight) : '';
                    let nastnum;
                    if (mItem.castunitidname) {
                        nastnum = "/" + mItem.nastnum + mItem.castunitidname;
                    }
                    return (
                        <div key={index}>
                            <div>{mItem.name}</div>
                            <div>
                                {
                                    realWeight
                                        ? <div><div>{realWeight}</div><div>|</div></div>
                                        : <div></div>
                                }
                                <div>{assignWeight}{mItem.dw}{nastnum}</div>
                            </div>
                        </div>
                    )
                })
                return (
                    <div key={index}>
                        <div>
                            <div>{aItem.address}</div>
                            <div>{dist}</div>
                        </div>
                        <div>{materilaList}</div>
                    </div>
                )
            });

            return (
                <div key={index} >
                    {
                        item.type === "load"
                            ? <div className="body-img-load"></div>
                            : <div className="body-img-unload"></div>
                    }
                    <div>
                        <div style={{ display: showDate }}>{date + ' ' + vcardid}</div>
                        <div className="body-unit">{item.unit}</div>
                        <div style={{ display: showView }}>
                            {addressList}
                        </div>
                    </div>
                </div>
            )
        })

        return (
            <div className="detail-page-top-card-container">
                <div className="card-wrapper-header">
                    <div className="header-left-vlicense">{data?.vlicense}</div>
                    <div>
                        <div>派车单号：{data?.vbillcode}</div>
                        <div onClick={this.switchStatus}>
                            <div className={iconStyle}></div>
                            <div>{text}</div>
                        </div>
                    </div>
                </div>
                <Card.Body>
                    <div className="card-wrapper-body">{list}</div>
                </Card.Body>
                {
                    (data?.stockorg?.pk_org === "0001A1100000000030MV") &&
                    <Card.Body>
                        <div className="card-wrapper-body">
                            <div className="card-button-box">
                                <Button
                                    onClick={this.getDeliveryFilesServlet}
                                    shape='rounded'
                                    color='primary'>
                                    报关单查询
                                </Button>
                            </div>
                            { (delivery?.filetype && delivery?.filestr) &&
                                <div className="card-img-box">
                                    <img src={deliverySrc} />
                                </div>
                            }
                        </div>
                    </Card.Body>
                }
                {/* <div className="card-wrapper-footer">
                    <div className="footer-img"></div>
                    <div className="footer-carrier">{data?.carrier?.vname}</div>
                </div> */}
            </div>
        )
    }
}
